app.service("ClicboxColourService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const ClicboxColourModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "clicbox_colour",
        navigation_pointer: "clicbox_colour_id",
        name: "Clicbox Colour",
        next_model_id: "select",
        choice_order: ['white', 'urban_oak', 'grey', 'dust_grey', 'anthracite']
    });

    this.factory = new modelConstructor.RouteFactory({

        choices: {
            white: new RouteChoice({
                name: "White",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-white.jpeg"
            }),
            urban_oak: new RouteChoice({
                name: "Urban Oak",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-urban-oak-square.jpeg"
            }),
            grey: new RouteChoice({
                name: "Grey",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-grey.png"
            }),
            dust_grey: new RouteChoice({
                name: "Dust Grey",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-dust-grey.png"
            }),
            anthracite: new RouteChoice({
                name: "Anthracite",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-anthracite.png"
            }),
            ivory: new RouteChoice({
                name: "Ivory",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-ivory.jpeg"
            })
        },

        birth: function (values) {
            return new ClicboxColourModel(values);
        },

        applyModelVariation: applyModelVariation
    });


    function applyModelVariation(model) {

        this.super(model);

        if($rootScope.navigation_model.state_ids.component_id !== "cabinet_bedroom"){
            model.choice_order = ['white', 'urban_oak', 'grey', 'dust_grey', 'anthracite'];
        } else {
            model.choice_order = ['white', 'urban_oak', 'grey'];
        }
    }

}]);